// extracted by mini-css-extract-plugin
module.exports = {"articleText":"ArticleBlocks_articleText__xgLZp"};